import z from "zod";
import { localeSchema, sessionRoleSchema, userSchema } from "../users";
import { assignableRoleEnum, organizationSchema } from "../organizations";
import { issueMessage, ValidationCode } from "../errors";
const emailInvalid = issueMessage(ValidationCode.EMAIL_INVALID, "Enter a valid email address");
const passwordTooShort = issueMessage(ValidationCode.PASSWORD_TOO_SHORT, "Password must be at least 8 characters");
export const loginSchema = z.object({
    email: z.email(emailInvalid),
    password: z.string().nonempty(issueMessage(ValidationCode.PASSWORD_REQUIRED, "Enter your password")),
});
export const preAuthTokenSchema = z.object({
    accessToken: z.string().nonempty(),
    user: userSchema,
});
export const tokenSchema = z.object({
    accessToken: z.string().nonempty(),
    user: userSchema,
    organization: organizationSchema,
    role: sessionRoleSchema,
    isSuperAdmin: z.boolean(),
});
export const preAuthJwtSchema = z.object({
    sub: z.int(),
    scope: z.literal("pre-auth"),
    iat: z.int(),
    exp: z.int(),
});
export const sessionJwtSchema = z.object({
    sub: z.int(),
    orgId: z.int(),
    role: sessionRoleSchema,
    scope: z.literal("session"),
    iat: z.int(),
    exp: z.int(),
});
export const selectOrganizationSchema = z.object({
    organizationId: z.number(),
});
export const registerSchema = z.object({
    email: z.email(emailInvalid),
    fullName: z.string().nonempty(issueMessage(ValidationCode.FULL_NAME_REQUIRED, "Enter your full name")),
    password: z.string().min(8, passwordTooShort),
    locale: localeSchema.optional(),
});
export const verifyEmailSchema = z.object({
    token: z.string().nonempty(issueMessage(ValidationCode.VERIFICATION_TOKEN_MISSING, "Verification token is missing")),
});
export const resendVerificationSchema = z.object({
    email: z.email(emailInvalid),
});
export const updateUserSchema = z.object({
    fullName: z.string().nonempty().optional(),
    locale: localeSchema.optional(),
});
export const forgotPasswordSchema = z.object({
    email: z.email(emailInvalid),
});
export const resetPasswordSchema = z.object({
    token: z.string().nonempty(issueMessage(ValidationCode.RESET_TOKEN_MISSING, "Reset token is missing")),
    password: z.string().min(8, passwordTooShort),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().nonempty(issueMessage(ValidationCode.CURRENT_PASSWORD_REQUIRED, "Enter your current password")),
    newPassword: z.string().min(8, passwordTooShort),
});
export const inviteUserSchema = z.object({
    email: z.email(),
    role: assignableRoleEnum,
});
export const createOrganizationSchema = z.object({
    name: z.string().min(1).max(256),
});
//# sourceMappingURL=auth.schema.js.map